module.exports = __webpack_public_path__ + "img/image_32.9bae9e2b.png";